import styled from 'styled-components'

import { Divider } from '@reveni-io/reveni-ui'

export const FullWidthDivider = styled(Divider)`
  width: auto;
  margin-left: -${props => props.theme.spacing.sp12};
  margin-right: -${props => props.theme.spacing.sp12};
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
`
